<template>
  <div class="tool-bar-wrap">
    <div v-if="showConfirms" class="confirmation-wrap">
      <or-icon-button
        icon="close"
        size="small"
        type="secondary"
        class="flat"
        disableRipple
        @click="discardHandler"
      />
      <or-icon-button
        v-if="!isLoading"
        icon="check"
        size="small"
        type="secondary"
        disableRipple
        class="flat"
        :disabled="confirmDisabled"
        @click="confirmHandler"
      />
    </div>
    <div v-else class="options-wrap">
      <div v-if="isLoading" class="loader-wrap">
        <span :class="isLoading ? 'loading' : ''">
          <or-icon icon="sync" />
        </span>
      </div>
      <or-icon-button
        v-else
        ref="dropdownButton"
        icon="more_vert"
        size="small"
        type="secondary"
        class="flat"
        has-dropdown
        disable-ripple
      >
        <or-menu
          slot="dropdown"
          contain-focus
          has-icons
          disable-ripple
          :options="menuOptions"
          @select="selectMenuHandler"
          @close="$refs.dropdownButton.closeDropdown()"
        />
      </or-icon-button>
    </div>
    <or-confirm
      ref="discard-changes-confirm"
      :title="$t('common.context.context_header_toolbar.discardChangesModal.title')"
      @confirm="cancelHandler"
    >
      {{ $t('common.context.context_header_toolbar.discardChangesModal.description') }}
    </or-confirm>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import { table_limits as tableLimits } from '@/modules/limits'
import KnowledgeBus from '@/KnowledgeBus'

export default {
  props: {
    newContext: Boolean,
    newContextName: String,
    newPair: Object,
    context: String,
    isLoading: Boolean,
    contextId: String,
    isPatternView: Boolean
  },

  computed: {
    ...mapState('knowledgebase', ['categories']),

    menuOptions () {
      return [
        { id: 'delete', label: this.$t('generic.delete'), icon: 'delete' },
        { id: 'edit', label: this.$t('common.context.context_header_toolbar.actions.editContext'), icon: 'edit' },
        { id: 'add', label: this.$t('common.context.context_header_toolbar.actions.addResponse'), icon: 'add' },
        { id: 'fe', label: this.$t('common.context.context_header_toolbar.actions.addFlow'), icon: 'add' }
      ]
    },

    localContext () {
      return this.context
    },

    showConfirms () {
      return (
        (this.editMode || this.addMode || this.newContext) && !this.isLoading
      )
    },

    confirmDisabled () {
      let isDisbled = true

      if (this.newContext) {
        const allIsEmpty =
          _.isEmpty(this.newContextName) ||
          (!this.isPatternView && _.isEmpty(this.newPair.utterance)) ||
          _.isEmpty(this.newPair.intent.name)

        isDisbled = allIsEmpty
      } else if (this.addMode) {
        if (this.isPatternView) {
          // TODO: add validation
        } else if (!_.inRange(this.newPair.utterance.length, tableLimits.utterance.min, tableLimits.utterance.max + 1)) {
          isDisbled = true
        }
        if (this.newPair.intent.type === 'TEXT' || this.newPair.intent.type === 'JSON') {
          isDisbled = this.newPair.intent.name.length === 0
        }
        if (this.newPair.intent.type === 'FLOW') {
          // TODO: add validation
          isDisbled = false
        }
      } else if (this.editMode) {
        isDisbled = !_.inRange(this.localContext.length, tableLimits.context.min, tableLimits.context.max + 1)
      }

      return isDisbled
    }
  },

  data () {
    return {
      addMode: false,
      editMode: false
    }
  },

  methods: {
    selectMenuHandler (value) {
      const valueId = value.id
      switch (valueId) {
        case 'delete':
          this.$emit('delete')
          break
        case 'edit':
          this.editMode = true
          this.$emit('edit')
          break
        case 'add':
          this.addMode = true
          this.$emit('add-pair')
          break
        case 'fe':
          this.addFlowEntity()
          break
      }
    },

    addFlowEntity () {
      KnowledgeBus.$emit('context-group-flow-entity::append', this.contextId)
    },

    discardHandler () {
      const allIsEmpty =
        _.isEmpty(this.newContextName) &&
        _.isEmpty(this.newPair.utterance) &&
        _.isEmpty(this.newPair.intent.name)

      if (this.newContext && allIsEmpty) {
        this.cancelHandler()
      } else if (this.newContext && !allIsEmpty) {
        this.$refs['discard-changes-confirm'].open()
      }

      if (this.editMode || this.addMode) {
        this.cancelHandler()
      }
    },

    cancelHandler () {
      if (this.editMode) {
        this.editMode = false
        this.$emit('deny', 'edit')
      }
      if (this.addMode) {
        this.addMode = false
        this.$emit('deny', 'add')
      }
      if (this.newContext) {
        KnowledgeBus.$emit('context-form::hide')
      }
    },

    confirmHandler () {
      if (this.editMode) {
        this.$emit('confirm', 'rename')
        return
      }
      if (this.addMode) {
        this.$emit('confirm', 'add')
        return
      }
      if (this.newContext) {
        this.$emit('confirm', 'new')
      }
    }
  },

  watch: {
    isLoading (value) {
      if (!value) {
        this.editMode = false
        this.addMode = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-bar-wrap {
  background: transparent;

  .loader-wrap {
    display: flex;
    width: 32px;
    height: 30px;
    align-items: center;
    justify-content: center;

    .material-icons {
      font-size: 18px;
      color: $or-blue;
      border-radius: 100%;

      @keyframes spin {
        100% {
          transform: rotate(-360deg);
        }
      }
      animation: spin 1s linear infinite;

      &:hover {
        cursor: default;
      }
    }
  }
}
</style>
